// Builds NOTAM field E from the AMSL height the assessor types, and copies
// individual fields or the whole five-field block (issue #168).
//
// All fields A-E are editable: A-D so the assessor can correct the generated
// dates/times (the DST/UTC reformat has edge cases), and E for free text. The
// copy buttons always copy the current, possibly edited, value of each field.
//
// Field E additionally auto-fills from the AMSL height until the assessor types
// in it: once edited we stop overwriting so their edit survives - and say so on
// the page, otherwise a stale height could go unnoticed.

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["maxHeightAmsl", "fieldA", "fieldB", "fieldC", "fieldD", "fieldE", "editedNote"];

    connect() {
        this.fieldETemplate = this.element.dataset.notamFieldETemplate || "";
        this.edited = false;
    }

    markEdited() {
        this.edited = true;
        this.editedNoteTarget.classList.remove("hide");
    }

    updateFieldE() {
        if (this.edited) return;

        const height = this.maxHeightAmslTarget.value;
        if (!/\d/.test(height)) {
            this.fieldETarget.value = "";
            return;
        }

        // The template carries an explicit {AMSL} token so the wording lives in
        // Ruby only - matching on prose like "SFC TO FT AMSL" would silently stop
        // working the moment the format changed.
        this.fieldETarget.value = this.fieldETemplate.replace("{AMSL}", height);
        this.showFadeEffect();
    }

    copyField(event) {
        const target = this[`field${event.currentTarget.dataset.field}Target`];
        this.copyText(target.value);
        this.flash(target);
    }

    copyAll() {
        const letters = ["A", "B", "C", "D", "E"];
        const targets = letters.map((l) => this[`field${l}Target`]);
        this.copyText(letters.map((l, i) => `${l}) ${targets[i].value}`).join("\n"));
        targets.forEach((target) => this.flash(target));
    }

    copyText(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
    }

    showFadeEffect() {
        this.fieldETarget.classList.add("notam-fade-effect");
        setTimeout(() => this.fieldETarget.classList.remove("notam-fade-effect"), 500);
    }

    // Flash the copied field grey to confirm what was copied.
    flash(target) {
        target.classList.add("notam-flash-effect");
        setTimeout(() => target.classList.remove("notam-flash-effect"), 200);
    }
}
